// extracted by mini-css-extract-plugin
module.exports = {"text":"styles_text__3XPKk","section":"styles_section__3__cc"};